import { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent, Typography } from '@mui/material';

export default function CallPopup({ title, phone }) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Button sx={{ bgcolor: 'secondary.lighter',borderRadius: 1 }} size="medium" color="secondary" onClick={handleOpen}>
        {title}
      </Button>
      <Dialog
        dir="rtl"
        fullWidth
        open={open}
        maxWidth="xs"
        onClose={handleClose}
        aria-labelledby="alert-dialog-call-popup"
        aria-describedby="alert-dialog-call-popup-description"
      >
        <DialogTitle id="alert-dialog-call-popup" color="text.disabled" textAlign="center">
          آیا از برقراری تماس مطمئن هستید؟
        </DialogTitle>
        <DialogContent>
          <Typography textAlign="center" variant="h2" color="text.secondary">
            {phone}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button fullWidth size='large' color="error" variant="outlined" onClick={handleClose}>
            فعلا نه
          </Button>
          <Button fullWidth size='large' color="secondary" variant="contained" href={`tel:${phone}`} autoFocus>
            تماس
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
